import CopyAllOutlined from "@mui/icons-material/CopyAllOutlined";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import ScoutIcon from "components/ScoutIcon";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { useCallback } from "react";

import { ScoutChatMessage } from "../hooks/useScoutChat";
export function AgentMessage({ message }: { message: ScoutChatMessage }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        py: 1.5,
        px: { xs: 2, sm: 3 },
      }}
    >
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
        sx={{
          maxWidth: "90%",
          px: 2,
          py: 1.25,
          borderRadius: 3,
          bgcolor: "transparent",
          color: "text.primary",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        <Box
          sx={{
            "@keyframes scoutSpin": {
              from: { transform: "rotate(0deg)" },
              to: { transform: "rotate(360deg)" },
            },
          }}
        >
          <ScoutIcon
            sx={{
              color: "#B0BEC5",
              animation: message.isStreaming ? "scoutSpin 1.1s linear infinite" : "none",
              transformOrigin: "center",
            }}
          />
        </Box>

        <Stack spacing={2}>
          <Typography variant="body1" component="div">
            {message.content}
          </Typography>
          <AgentMessageToolbar message={message} />
        </Stack>
      </Stack>
    </Box>
  );
}

function AgentMessageToolbar({ message }: { message: ScoutChatMessage }) {
  const copyToClipboard = useCopyToClipboard();

  const handleCopy = useCallback(async () => {
    const text = message.content ?? "";
    await copyToClipboard(text);
  }, [copyToClipboard, message.content]);

  return (
    <Stack width="100%" direction="row" alignItems="center" spacing={1}>
      <Tooltip title="Copy text">
        <IconButton aria-label="Copy text" size="small" onClick={handleCopy}>
          <CopyAllOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
